/**
 * Prerender / reduced-motion awareness.
 *
 * scripts/prerender.js sets `window.__DD_PRERENDER__ = true` before the app
 * boots (via Puppeteer `evaluateOnNewDocument`). Components that animate text
 * or numbers should render their FINAL state when this flag is set, so the
 * captured static HTML that crawlers and no-JS clients receive is complete
 * (no words hidden at opacity:0, no counters frozen at 0).
 */
export function isPrerender() {
  return typeof window !== 'undefined' && window.__DD_PRERENDER__ === true;
}

export function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/** True when animations should be skipped and final values shown immediately. */
export function shouldSkipAnimation() {
  return isPrerender() || prefersReducedMotion();
}
